module.exports = "https://cdn.realtymogul.com/static/media/GS_steps_3.906e4c3e.jpg";